/**
 * 默认组件映射表 —— 声明可被国家替换的组件槽位
 *
 * ═══════════════════════════════════════════════════════════
 * 命名规则：ModulePageSlot（大驼峰，无连字符）
 * ═══════════════════════════════════════════════════════════
 *
 *  部分              含义                       示例
 * ─────────────────────────────────────────────────────────
 *  ModulePageSlot    模块+页面+插槽拼接          AddressCascadeSelector / HomeDashboardWidget
 *
 * 多模块共用的组件槽位，使用 "Common" 前缀：
 *   例：CommonExportDialog
 *
 * key 是组件槽位名，value 是默认组件（动态 import）或 null（表示不渲染）
 * 国家层用同名 key 覆写为自己的组件
 */
const standardComponents: Record<string, any> = {
  /** 地址级联选择器组件（默认无，VN/MY 各自覆写） */
  AddressCascadeSelector: null,

  /** 首页仪表盘自定义区域 */
  HomeDashboardWidget: null,

  /** 登录页隐私政策和用户条款组件 */
  LoginPrivacyPolicyModal: null,

  /** Cookie 授权弹窗（默认无，DE 覆写） */
  ComplianceCookieConsentBanner: null,
  /** 手机号脱敏组件 */
  DecryptIdCard: null,
}

export default standardComponents
